import { ReactQueryKeys } from "constants/keys";

export interface NamedSettingsResourceConfig {
  resourcePath: string;
  bodyKey: string;
  singularLabel: string;
  pluralLabel: string;
  tabPath: string;
  listQueryKey: ReactQueryKeys;
  itemQueryKey: ReactQueryKeys;
  // When true, the resource carries an optional structured US address
  // (line1/line2/city/state/zip/country) alongside its name.
  supportsAddress?: boolean;
}

export const comorbidityResource: NamedSettingsResourceConfig = {
  resourcePath: "comorbidities",
  bodyKey: "comorbidity",
  singularLabel: "Comorbidity",
  pluralLabel: "Comorbidities",
  tabPath: "/settings/comorbidities",
  listQueryKey: ReactQueryKeys.COMORBIDITIES,
  itemQueryKey: ReactQueryKeys.COMORBIDITY,
};

export const clearanceResource: NamedSettingsResourceConfig = {
  resourcePath: "clearances",
  bodyKey: "clearance",
  singularLabel: "Clearance",
  pluralLabel: "Clearances",
  tabPath: "/settings/clearances",
  listQueryKey: ReactQueryKeys.CLEARANCES,
  itemQueryKey: ReactQueryKeys.CLEARANCE,
};

export const hospitalResource: NamedSettingsResourceConfig = {
  resourcePath: "hospitals",
  bodyKey: "hospital",
  singularLabel: "Hospital",
  pluralLabel: "Hospitals",
  tabPath: "/settings/hospitals",
  listQueryKey: ReactQueryKeys.HOSPITALS,
  itemQueryKey: ReactQueryKeys.HOSPITAL,
  supportsAddress: true,
};

export const surgeonResource: NamedSettingsResourceConfig = {
  resourcePath: "surgeons",
  bodyKey: "surgeon",
  singularLabel: "Surgeon",
  pluralLabel: "Surgeons",
  tabPath: "/settings/surgeons",
  listQueryKey: ReactQueryKeys.SURGEONS,
  itemQueryKey: ReactQueryKeys.SURGEON,
};
